import * as React from 'react' // for tsx

import * as render from '@shanhuio/misc/dist/render'
import * as redraw from '@shanhuio/misc/dist/redraw'
import * as ajax from '@shanhuio/misc/dist/ajax'

export class PageData {
    SignUp: boolean // if this is a sign up form or a sign in form.
    Redirect: string // after signing in, where to redirect.
}

class Response {
    Error: string
}

class SignIn {
    data: PageData
    redraw: redraw.Redraw
    caller: ajax.Caller
    account: string = ''
    password: string = ''
    error: string = ''

    constructor(r: redraw.Redraw, data: PageData) {
        this.redraw = r
        this.data = data
        this.caller = new ajax.Caller()
    }

    checkFormInput(): string {
        if (!this.account) return 'Email or endpoint name is empty.'
        if (!this.password) return 'Password is empty.'
        return ''
    }

    clear() {
        this.account = ''
        this.password = ''
        this.error = ''
    }

    handleResp(resp: Response) {
        if (resp.Error) {
            this.error = resp.Error
            this.redraw()
            return
        }
        this.clear()
        this.redraw()
        var redirect = this.data.Redirect
        if (!redirect) { redirect = '/dashboard' }
        window.location.replace(redirect)
    }

    submit() {
        this.error = this.checkFormInput()
        if (this.error) {
            this.redraw()
            return
        }

        if (this.data.SignUp) {
            this.caller.call('/pubapi/user/signup', {
                Email: this.account,
                Password: this.password,
            }, {
                success: (d: any, status: string, xhr: JQueryXHR) => {
                    this.handleResp(d as Response)
                },
                error: (xhr: JQueryXHR, status: string, err: string) => {
                    this.error = status + ' - ' + err
                    this.redraw()
                },
            })
            return
        }
        this.caller.call('/pubapi/user/signin', {
            Account: this.account,
            Password: this.password,
        }, {
            success: (d: any, status: string, xhr: JQueryXHR) => {
                this.handleResp(d as Response)
            },
            error: (xhr: JQueryXHR, status: string, err: string) => {
                this.error = status + ' - ' + err
                this.redraw()
            },
        })
    }

    actionText(): string {
        if (this.data.SignUp) return 'Sign Up'
        return 'Sign In'
    }

    signInWith(provider: string): string {
        return this.actionText() + ' With ' + provider
    }

    signInLink(base: string): string {
        if (!this.data.Redirect) return base
        return base + '?r=' + encodeURIComponent(this.data.Redirect)
    }

    renderGitHubButton(): JSX.Element {
        let link = this.signInLink('/github/signin')
        return <div className="button"><a href={link}>
            <span className="github">{this.signInWith('GitHub')}</span>
        </a></div>
    }

    renderGoogleButton(): JSX.Element {
        let link = this.signInLink('/google/signin')
        return <div className="button"><a href={link}>
            <span className="google">{this.signInWith('Google')}</span>
        </a></div>
    }

    renderFirstTimeHint(): JSX.Element {
        if (this.data.SignUp) return null
        let signUpLink = this.signInLink('/signup')
        return <div className="first-time">
            When you sign in with GitHub and Google for the first time, <br />
            a new account will be created automatically. <br />
            You can also <a href={signUpLink}>sign up with Email</a>.
        </div>
    }

    renderError(): JSX.Element {
        if (!this.error) return null
        return <div className="error">{this.error}</div>
    }

    render(): JSX.Element {
        let submit = (ev: React.FormEvent<HTMLElement>) => {
            this.submit()
            ev.preventDefault()
        }

        let accountChange = (ev: React.FormEvent<HTMLElement>) => {
            this.account = (ev.target as HTMLInputElement).value
        }
        let passwordChange = (ev: React.FormEvent<HTMLElement>) => {
            this.password = (ev.target as HTMLInputElement).value
        }

        let accountPrompt = this.data.SignUp ?
            'Email' : 'Email or endpoint name'

        let forget = this.data.SignUp ?
            <a href={this.signInLink('/signin')}>Already signed up?</a> :
            <a href="/reset-password">Forget password?</a>

        let form = <form method="POST" action="#" onSubmit={submit}>
            {this.renderError()}
            <div className="line">
                <div className="prompt">{accountPrompt}</div>
                <input
                    name="account" type="input" autoFocus
                    onChange={accountChange}
                />
            </div>
            <div className="line">
                <div className="prompt">Password</div>
                <input
                    name="password" type="password"
                    onChange={passwordChange}
                />
            </div>
            <div className="line">
                <button type="submit">{this.actionText()}</button>
                <span className="alt-action">{forget}</span>
            </div>
        </form>
        return <div className="tcol">
            {form}
            <div className="or">or</div>
            {this.renderGitHubButton()}
            {this.renderGoogleButton()}
            {this.renderFirstTimeHint()}
        </div>
    }
}

interface Props { pageData: PageData }

class Main extends React.Component<Props, {}> {
    redraw: redraw.Redraw
    signIn: SignIn

    constructor(props: Props) {
        super(props)
        this.redraw = redraw.NewRedraw(this)
        this.signIn = new SignIn(this.redraw, props.pageData)
    }

    render(): JSX.Element { return this.signIn.render() }
}

export function main(d: PageData) {
    render.mainElement(<Main pageData={d} />)
}
